function  Statistic() {

    let statisticContent = [
        {
            number: 40,
            text: 'спікерів'
        },
        {
            number: 6,
            text: 'панельних дискусій'
        },
        {
            number: 500,
            text: 'учасників офлайн'
        },
        {
            number: 8000,
            text: 'глядачів онлайн трансляції'
        }
    ]

    return (
        <section className="relative bg-[#009064] mb-10 md:mb-14">
            <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px]">
                <div className="grid grid-cols-2 py-12 gap-8 md:flex xl:px-9">
                    {
                        statisticContent?.map((item, index) => {
                            return (
                                <div className="relative text-white flex flex-col items-center text-center md:flex-auto lg:gap-2" key={index}>
                                    <div className="relative">
                                        <span className="relative font-medium text-[45px] leading-none lg:text-7xl ">{item.number}</span>

                                        <span class="absolute top-2 -right-3 w-5 h-5 lg:w-8 lg:h-8 lg:-right-5 bg-[#F5D858] rounded-full flex items-center justify-center">
                                            <svg viewBox="0 0 24 24" class="w-3 h-3 lg:w-5 lg:h-5">
                                                <path d="M12 5v14M5 12h14" stroke="black" stroke-width="2" stroke-linecap="round"/>
                                            </svg>
                                        </span>
                                    </div>
                                    <span className="lg:text-xl">{item.text}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )

}

export default Statistic;